// extracted by mini-css-extract-plugin
export var footer = "new-footer-module--footer--fd51e";
export var footer__bl = "new-footer-module--footer__bl--10ad2";
export var footer__bottom = "new-footer-module--footer__bottom--5db86";
export var footer__bottomTxt = "new-footer-module--footer__bottom-txt--3d477";
export var footer__contacts = "new-footer-module--footer__contacts--aa5f4";
export var footer__contactsLink = "new-footer-module--footer__contacts-link--d1f87";
export var footer__contactsTxt = "new-footer-module--footer__contacts-txt--75baf";
export var footer__descript = "new-footer-module--footer__descript--a78bd";
export var footer__li = "new-footer-module--footer__li--a035c";
export var footer__menu = "new-footer-module--footer__menu--f9f49";
export var footer__menuLi = "new-footer-module--footer__menu-li--3b5a9";
export var footer__menuLink = "new-footer-module--footer__menu-link--85626";
export var footer__socLink = "new-footer-module--footer__soc-link--6d31f";
export var footer__social = "new-footer-module--footer__social--bc9fe";
export var footer__title = "new-footer-module--footer__title--8d517";
export var footer__top = "new-footer-module--footer__top--97b7c";
export var footer_manage = "new-footer-module--footer_manage--8e1d7";
export var manage = "new-footer-module--manage--f0999";